import { useLevelPlaySurface } from '@/shared/level-play'
import { FormControl } from '@/shared/ui/Form'




export const LevelPlayQuestionText = () => {
  const { answerIsWrong, answerIsRight, disableInputs } = useLevelPlaySurface()
  let borderColor = ''
  if (answerIsRight) {
    borderColor = 'border-success'
  } else if (answerIsWrong) {
    borderColor = 'border-danger'
  }

  return (
    <FormControl
      name="answer"
      required
      placeholder="Insira a resposta aqui"
      as="textarea"
      className={`text-base pt-4 px-4 border-2 ${borderColor}`}
      rows={5}
      disabled={disableInputs}
    />
  )
}
